<template>
  <v-container fluid style="height:100%" pa-0 ma-0>
    <CompaniesTable />
  </v-container>  
</template>


<script>
import CompaniesTable from './../../components/blocks/CompaniesTable'
export default {
    components: {
      CompaniesTable,
    },
    data () {
      return {
        
      }
    },
    mounted() {
    },
    computed: {
    },
    created () {},
    methods: {
      
      example(message) {
        
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/views/Companies.vue